import React, { useState } from "react"
import axios from "axios"
import styled, { css } from "styled-components"
import { Formik } from "formik"
import { useIntl } from "gatsby-plugin-react-intl"

import { Row, Col } from "./Grid"
import Button from "./Button"
import Spacer from "./Spacer"
import { Form, Input, Checkbox, SubmitOverlay } from "./FormFields"
import Confirmation from "./Confirmation"

import { schema } from "../../schemas/newsletter"
import { trackEvent } from "../helpers/tracking"

import { mixins } from "../styles"

const debugForm = process.env.GATSBY_DEBUG_FORMS === "true"

const Wrapper = styled.div`
  iframe {
    display: none;
    margin: 60px 0 0;
    height: 400px;
    width: 100%;

    ${(props) =>
      props.$debugForm &&
      css`
        display: block;
      `}
  }
`

const ErrorAlert = styled.div`
  color: var(--color-error);
  ${mixins.copy4};
  font-weight: 700 !important;
  margin: 0 0 30px;
`

const FormNewsletter = () => {
  const intl = useIntl()
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(false)

  return (
    <Wrapper $debugForm={debugForm}>
      {submitted ? (
        <Row>
          <Col sm="10" smOffset="1" lg="8" lgOffset="2">
            <Confirmation
              status="success"
              text={intl.formatMessage({
                id: "forms.newsletter.confirmationText",
              })}
            />
          </Col>
        </Row>
      ) : (
        <>
          <Formik
            initialValues={{
              email: "",
              consent: false,
            }}
            validationSchema={schema({ language: intl.locale })}
            onSubmit={async (values, { setSubmitting }) => {
              setError(false)
              const request = {
                consent: values.consent,
                email: values.email,
                language: intl.locale,
              }
              try {
                const response = await axios.post("/api/newsletter", request)

                trackEvent({
                  category: "Newsletter",
                  action: "Signup",
                  name: "Newsletter Signup",
                })

                setSubmitted(true)
                setSubmitting(false)
                debugForm && console.log(response)
              } catch (error) {
                setError(true)
                console.log(error.response)
              }
            }}
          >
            {({ handleSubmit, isSubmitting }) => (
              <Form
                aria-label={intl.formatMessage({
                  id: "forms.newsletter.ariaLabel",
                })}
                onSubmit={handleSubmit}
              >
                <Input
                  name="email"
                  type="email"
                  label={intl.formatMessage({
                    id: "forms.email",
                  })}
                  autoComplete="email"
                  required
                />
                <Spacer height={10} />
                <Checkbox autoComplete="off" name="consent" required>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({
                        id: "forms.newsletter.consent",
                      }),
                    }}
                  />
                </Checkbox>
                <Spacer height={30} />
                <Button as="button" type="submit" arrow>
                  {intl.formatMessage({
                    id: "forms.subscribe",
                  })}
                </Button>
                {isSubmitting && <SubmitOverlay background="white" />}
              </Form>
            )}
          </Formik>
        </>
      )}
      {error && (
        <ErrorAlert>
          {intl.formatMessage({ id: "forms.errors.serverError" })}
        </ErrorAlert>
      )}
    </Wrapper>
  )
}

export default FormNewsletter
